import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteTourStatusCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [DeleteTourStatusCommandService],
  exports: []
})
export class DeleteTourStatusCommandServiceModule { }
